/* global axios */
import ApiClient from '../ApiClient';

class WizardTools extends ApiClient {
  constructor() {
    super('wizard/assistants/tools', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, {
      params,
    });
  }
}

export default new WizardTools();
